module.exports = __webpack_public_path__ + "img/nidianatalbw.4b856da1.webp";